let _exp = undefined
const { getConfig, getProps } = window.jplusUtil

export default class Olfactory {
    constructor(epx) {
        _exp = epx
        this.removeT = undefined
        this.insetT = undefined
        this.options = []
        this.onEventListener()
        this.onscroll()
    }
    initConfig() {
        this.config = []
        getConfig('exp').map((item, index) => {
            const { config, expShouldRecord, expWillRecord, expDidRecord } = item
            config.selector = config.selector || '.jplus-exp'
            config.visible = config.visible || '0.3'
            config.duration = config.duration || '300'
            config.method = config.method || 'get'
            config.postSize = config.postSize || '10'
            config.tagName = config.tagName || 'data-jplus-exp'
            config.propsMap = config.propsMap || {
                url: 'data-jplus-exp-url'
            }
            config.groupIndex = index
            this.config.push(Object.assign(config, {
                expShouldRecord,
                expWillRecord,
                expDidRecord
            }))
        })
    }
    supConfig(ele, index) {
        let url = undefined
        const config = this.config[index]
        if(ele) {
            const props = getProps(ele)
            url = props[config.propsMap.url]
            const newConfig = Object.assign({}, config, {
                ele,
                url,
                props
            })
            this.config[index] = newConfig
            return newConfig
        }
    }
    onEventListener() {
        window.addEventListener("scroll", this.onscroll.bind(this))

        window.addEventListener("DOMNodeInserted", (event) => {
            try {
                if(!this.insetT) {
                    this.insetT = setTimeout(() => {
                        this.onscroll()
                        clearTimeout(this.insetT)
                        this.insetT = undefined
                    }, 100)
                }
            } catch(e) {
                console.error(e)
            }
        })

        window.addEventListener("DOMNodeRemoved", (event) => {
            try {
                if(!this.removeT) {
                    this.removeT = setTimeout(() => {
                        this.onscroll()
                        clearTimeout(this.removeT)
                        this.removeT = undefined
                    }, 100)
                }
            } catch(e) {
                console.error(e)
            }
        })
    }

    // 轮询
    onscroll() {
        if (this.scrollTimer) {
            clearTimeout(this.scrollTimer);
        }
        this.scrollTimer = setTimeout(() => {
            if (this.scrollTimer) {
                clearTimeout(this.scrollTimer)
            }
            this.calculate()
        }, 50)
    }

    // 计算dom
    calculate() {
        const scrollTop =
            document.documentElement.scrollTop ||
            window.pageYOffset ||
            document.body.scrollTop
        const scrollBottom = scrollTop + document.documentElement.clientHeight
        this.initConfig()
        this.config.map((item, index) => {
            const selector = item['selector']
            const els = document.querySelectorAll(selector) || []

            //检测元素
            for (let i = 0; i < els.length; i++) {
                const ele = els[i];
                if (ele.style.visibility != "hidden" && ele.style.display != "none") {
                    const jplustag = ele.getAttribute(item.tagName)
                    if (jplustag) continue;
                    //判断是否在视野区域
                    const top = this.getDocumentOffsetTop(ele)
                    const height = ele.offsetHeight
                    const bottom = top + height
                    const inTop = top + height * item.visible
                    const inBottom = bottom - height * item.visible

                    if (inBottom > scrollTop && inTop < scrollBottom) {
                        // 在视口，等待发送，需要发送
                        // 避免重复发送
                        // 出发标识
                        const newConfig = this.supConfig(ele, index)
                        _exp.record(newConfig, ele, newConfig.props, this.config)
                    }
                }
            }
        })
    }

    // 计算父节点
    getDocumentOffsetTop(ele) {
        // ele.offsetParent 取最近的ele的父级别元素 定位部位position 不为static 的元素
        if (ele.offsetParent !== null) {
            const top = this.getDocumentOffsetTop(ele.offsetParent);
            return ele.offsetTop + top;
        } else {
            return ele.offsetTop;
        }
    }
}
